/**
 * Chatbot popup func
 * @author Ana Chan
 * @package Dunfermline
 */

const ChatBotPopup = () => {
    const modal = document.getElementById('mobile-chat-modal');
    if (!modal) return;

    const mobileChatButton = document.querySelector('.mobile-chat-button');

    mobileChatButton.addEventListener('click', () => {
        modal.classList.remove('hide');
    });

    const closeButton = document.querySelector('.close-chat');
    closeButton.addEventListener('click', () => {
        modal.classList.add('hide');
    });
};

export default ChatBotPopup;
